module.exports = __webpack_public_path__ + "img/hsbc.486f197.svg";